import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const eventMappings = {};
eventMappings[actions.CHECK_REGISTRATION_COMPLETED] = [trackCompleteAction];
eventMappings[actions.CHECK_REGISTRATION_CANCELLED] = [trackCancelAction];

export default function trackCheckRegistration(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: state.checkRegistration.actionCompletionTime
    });
}

function trackCancelAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: state.checkRegistration.actionCancelledTime
    });

    apiTracking.trackCancelAction(state, state.checkRegistration.actionCancelledTime);
}
